
import { mapState } from 'vuex'
import { RoutesListFn } from '@/router'
export default {
  data() {
    return {
      RoutesList: RoutesListFn(this.$route.params.site),
      moduleName1: 'home',
      moduleName2: '', // 二级
      moduleName3: '', // 三级
      searchInput: '',
      close: false,
      site: this.$route.params.site,
      lang: this.$route.params.lang,
    }
  },
  computed: {
    ...mapState({
      isHome: (state) => state.isHome,
      locale: (state) => state.locale,
      isHdFtMobile: (state) => state.isHdFtMobile,
      isPopup: (state) => state.isPopup,
      isAgree: (state) => state.cookie_agree.agree,
      headerHeight: (state) => state.headerHeight,
    }),
  },
  mounted() {
    // 动态获取头部高度
    const headerHeight = document.getElementById('header').offsetHeight
    this.$store.commit('SET_HEADER_HEIGHT', headerHeight + 'px')
  },
  created() {
    this.setDefaultActive()
  },
  methods: {
    switchItem(switchKey) {
      if (process.client) {
        return window?.[switchKey] || false
      }
      return false
    },
    setDefaultActive() {
      const that = this
      // 选中
      const fullNameArray = this.$route.name
        .replace('site-lang-', '')
        .replace('site-lang', '')
        .split('-')

      fullNameArray.forEach(
        (item, index) => (that['moduleName' + (index + 1)] = item)
      )
      this.moduleName1 = this.moduleName1 || 'home'
    },
    closed(val) {
      if (this.isHdFtMobile) {
        this.close = val
      }
    },
    closePopup() {
      this.$store.commit('saveIsPopup', false)
    },
    checkOrder() {
      this.$router.push({
        name: 'site-lang-support-querySupport-waybill',
        params: {
          site: this.$route.params.site,
          lang: this.$route.params.lang,
        },
        query: {
          No: this.searchInput,
        },
      })
    },
    handleHrefClick(item) {
      item?.trackFn && item?.trackFn()
    },
  },
}
